/* @ngInject */
function SocialMediaStoryController ($scope, $timeout, $interval) {
  let timerInterval = null
  let currentTimerProgress = 0

  $scope.images = []
  $scope.currentImageIndex = 0
  $scope.hasMultipleImages = false
  $scope.currentImageUrl = ''

  const api = {
    _setImages,
    _setCurrentIndex,
    _startTimer,
    _stopTimer,
    _resetTimer
  }

  this.getApi = () => api

  $scope.goToPrevious = () => {
    if ($scope.images.length <= 1) return

    $scope._stopTimer()

    if ($scope.currentImageIndex > 0) {
      $scope.currentImageIndex = $scope.currentImageIndex - 1
    } else {
      $scope.currentImageIndex = 0
    }

    $scope._updateCurrentImage()
    $scope._resetTimer()
    $scope._startTimer()
  }

  $scope.goToNext = () => {
    if ($scope.images.length <= 1) return

    $scope._stopTimer()
    $scope.currentImageIndex = $scope.currentImageIndex < $scope.images.length - 1 ? $scope.currentImageIndex + 1 : 0
    $scope._updateCurrentImage()
    $scope._resetTimer()
    $scope._startTimer()
  }

  $scope.getTimerProgress = (index) => {
    if (index < $scope.currentImageIndex) {
      return { width: '100%' }
    } else if (index === $scope.currentImageIndex) {
      return { width: currentTimerProgress + '%' }
    } else {
      return { width: '0%' }
    }
  }

  $scope._updateCurrentImage = () => {
    if ($scope.images && $scope.images.length > 0) {
      const currentImage = $scope.images[$scope.currentImageIndex]
      $scope.currentImageUrl = currentImage?.url || currentImage?.thumbnailUrl || currentImage?.thumbnail || ''
    } else {
      $scope.currentImageUrl = $scope.imageUrl || ''
    }
  }

  $scope._startTimer = () => {
    if ($scope.images.length <= 1) return

    $scope._stopTimer()

    timerInterval = $interval(() => {
      currentTimerProgress += 2 // Increment by 2% every ~60ms for smooth animation

      if (currentTimerProgress >= 100) {
        $scope._stopTimer()
        $scope.goToNext()
      }
    }, 60)
  }

  $scope._stopTimer = () => {
    if (timerInterval) {
      $interval.cancel(timerInterval)
      timerInterval = null
    }
  }

  $scope._resetTimer = () => {
    currentTimerProgress = 0
  }

  function _setImages (images) {
    $scope.images = images || []
    $scope.hasMultipleImages = $scope.images.length > 1
    $scope.currentImageIndex = 0
    $scope._updateCurrentImage()

    if ($scope.hasMultipleImages) {
      $scope._resetTimer()
      $scope._startTimer()
    }
  }

  function _setCurrentIndex (index) {
    if ($scope.images.length <= 1) return

    $scope._stopTimer()
    $scope.currentImageIndex = Math.max(0, Math.min(index, $scope.images.length - 1))
    $scope._updateCurrentImage()
    $scope._resetTimer()

    if ($scope.hasMultipleImages) {
      $scope._startTimer()
    }
  }

  function _startTimer () {
    $scope._startTimer()
  }

  function _stopTimer () {
    $scope._stopTimer()
  }

  function _resetTimer () {
    $scope._resetTimer()
  }

  activate()
  function activate () {
    $scope.$watch('materials', (newMaterials) => {
      if (newMaterials && newMaterials.length > 0) {
        api._setImages(newMaterials)
      }
    }, true)

    $scope.$watch('selectedIndex', (newIndex) => {
      if (newIndex !== null && newIndex !== undefined) {
        api._setCurrentIndex(newIndex)
      }
    })

    if ($scope.imageUrl && !$scope.materials) {
      $scope.currentImageUrl = $scope.imageUrl
      $scope.hasMultipleImages = false
    }
  }

  $scope.$on('$destroy', () => {
    if (timerInterval) {
      $interval.cancel(timerInterval)
    }
  })
}

export { SocialMediaStoryController }
